import React from 'react';
import { Steps, Breadcrumb, Layout, notification, Modal } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { graphql, compose, withApollo } from 'react-apollo';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actionsAutorizacion from '../../../actions/autorizacionTrabajoMenor';
import * as actionsMain from '../../../actions/main';

import SelectorModelo from '../formularios/SelectorModelo';
import FormAutorizacionTrabajoMenor from '../formularios/FormAutorizacionTrabajoMenor';
import Generador from '../../generador/Generador';
import CKEditor from '../../editor/Example';
import Loading from '../../common/Loading';

import VerPersonas from './VerPersonas';
import CrearEmpleador from './CrearEmpleador';

import insertPersona from '../../../graphql/mutations/persona/insertPersona.graphql';
import insertEmpleador from '../../../graphql/mutations/empleador/insertEmpleador.graphql'
import insertAutorizacionTrabajoMenor from '../../../graphql/mutations/tramites/insertAutorizacionTrabajoMenor.graphql';
import updateAutorizacionTrabajoMenorPorId from '../../../graphql/mutations/tramites/updateAutorizacionMenorPorId.graphql';
import subirAutorizacionTrabajoMenorHTML from '../../../graphql/mutations/tramites/subirAutorizacionTrabajoMenorHTML.graphql';
import crearAutorizacionTrabajoMenor from '../../../graphql/mutations/tramites/crearAutorizacionTrabajoMenor.graphql';
import confirmarAutorizacionTrabajoMenor from '../../../graphql/mutations/tramites/confirmarAutorizacionTrabajoMenor.graphql';
import obtenerNumeroTalonario from '../../../graphql/mutations/editor/obtenerNumeroTalonario.graphql';
import insertDetalleVenta from '../../../graphql/mutations/venta/insertDetalleVenta.graphql';
import insertVenta from '../../../graphql/mutations/venta/insertVenta.graphql';

import { imprimir } from '../../common/funciones/imprimir';
import { verPdf } from '../../common/funciones/verPdf';

import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';

import moment from 'moment';
import _ from 'lodash';
import { errorService } from '../../../graphql/utils/utils';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

const { Content } = Layout;
const confirm = Modal.confirm;

@compose(
  graphql(insertAutorizacionTrabajoMenor, {
    name: 'createAutorizacion',
  }),
  graphql(crearAutorizacionTrabajoMenor, {
    name: 'crearAutorizacionTrabajoMenor',
  }),
  graphql(confirmarAutorizacionTrabajoMenor, {
    name: 'confirmarAutorizacionTrabajoMenor',
  }),
  graphql(updateAutorizacionTrabajoMenorPorId, {
    name: "updateAutorizacionTrabajoMenorPorId",
  }),
  graphql(subirAutorizacionTrabajoMenorHTML, {
    name: 'subirAutorizacionTrabajoMenorHTML',
  }),
  graphql(insertPersona, {
    name: 'createPers',
  }),
  graphql(insertEmpleador, {
    name: 'insertEmpleador',
  }),
  graphql(insertDetalleVenta, {
    name: 'insertDetalleVenta',
  }),
  graphql(insertVenta, {
    name: 'insertVenta',
  }),
  graphql(getUsuario)
)
class CrearAutorizacionTrabajoMenor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      nota: {
        idModeloNota: '',
        titulo: '',
        descripcion: '',
        htmlModelo: '',
      },
      autorizado: {},
      autorizante: {},
      responsable: {},
      empleador: {},
      vinculo_autorizante: '',
      numero_acta_nacimiento: '',
      domicilioActividad: '',
      mailsNotificar:[],
      telefonos:[],
      cantidad_dias: '',
      // tipo_autorizacion: "",
      destinos: '',
      step: 0,
      guardado: false,
      pendienteCargaPersona: false,
      detalles: [],
      datosPosnet: {},
      extras: {},
    };

    this.guardarDatosAutorizacion = this.guardarDatosAutorizacion.bind(this);
    this.notaSeleccionada = this.notaSeleccionada.bind(this);
    this.siguientePaso = this.siguientePaso.bind(this);
    this.anteriorPaso = this.anteriorPaso.bind(this);

    this.confirmarAutorizacionTrabajoMenor = this.props.confirmarAutorizacionTrabajoMenor.bind(this);
    this.updateAutorizacionTrabajoMenorPorId = this.props.updateAutorizacionTrabajoMenorPorId.bind(this);
    this.guardarAutorizacion = this.guardarAutorizacion.bind(this);
    this.finProcesoGeneracion = this.finProcesoGeneracion.bind(this);
    this.obtenerDatosGeneracion = this.obtenerDatosGeneracion.bind(this);
    this.onImprimir = this.onImprimir.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  componentDidUpdate() {
    // console.log("component did update")
    if (this.state.pendienteCargaPersona) {
      // console.log("%%%%%%%%%%%%% es tiempo deeeee %%%%%%%%%", this.state);
      if (
        this.state.autorizado._id &&
        this.state.autorizante._id &&
        this.state.responsable._id
      ) {
        // console.log("Es tiempo de crear la autorizacion");
        this.crearyPersistirAutorizacion();
      }
    }
  }

  componentDidMount() {
    // console.log("Entre al component did Mount!!!!");
    this.props.actionsMain.reiniciar();
  }

  guardarDatosAutorizacion(datos, ventaSinStock) {
    // Regex to split by common separators: comma, semicolon, pipe, space(s), slash, backslash, newline, tab
    const separatorRegex = new RegExp('[,;|\\s/\\\\]+');
    
    let mailsNotificarArray = [];
    if (datos.mailsNotificar) {
      mailsNotificarArray = datos.mailsNotificar
        .split(separatorRegex)
        .map(s => s.trim())
        .filter(s => s.length > 0);
    }
    let telefonosArray = [];
    if (datos.telefonos) {
      telefonosArray = datos.telefonos
        .split(separatorRegex)
        .map(s => s.trim())
        .filter(s => s.length > 0);
    }
    this.setState(
      {
        ...this.state,
        vinculo_autorizante: datos.vinculo_autorizante,
        numero_acta_nacimiento: datos.numero_acta_nacimiento,
        domicilioActividad: datos.domicilioActividad,
        cantidad_dias: datos.cantidad_dias,
        desde: datos.desde,
        hasta: datos.hasta,
        mailsNotificar: mailsNotificarArray,
        telefonos: telefonosArray,

        // tipo_autorizacion: datos.tipo_autorizacion,
        destinos: datos.destinos,
        existeVenta: datos.existeVenta,
        detalles: datos.detalles,
        datosPosnet: datos.datosPonset,
        datosMP: datos.datosMP,
        extras: datos.extras,
        loading: true,
      },
      function() {
        this.props.actionsAutorizacion.setAutorizacionTrabajoMenor({
          numero_acta_nacimiento: datos.numero_acta_nacimiento,
          domicilioActividad: datos.domicilioActividad,
          cantidad_dias: datos.cantidad_dias,
          destinos: datos.destinos,
          desde: datos.desde,
          hasta: datos.hasta,
        });
        // this.siguientePaso();
        this.crearyPersistirAutorizacion(ventaSinStock);
      }
    );
  }

  notaSeleccionada(idNota) {
    this.setState({
      ...this.state,
      nota: {
        idModeloNota: idNota,
      },
    });
  }

  obtenerDatosGeneracion() {
    //Este metodo es el encargado de, dependiendo lo necesario, de generar un unico objeto que
    //Será utilizado para pasarselo al componente generador como datos de entradas.

    let vinculos = [];
    _.forEach(this.state.autorizacion.autorizantes, autorizante => {
      vinculos.push(autorizante.vinculo);
    });

    // console.log("LOS VINCULOS ME QUEDAN: ");
    // console.log(vinculos);

    let stringVinculos = '';
    if (vinculos) {
      if (vinculos.length == 1) {
        stringVinculos = vinculos[0];
      }
      if (vinculos.length == 2) {
        stringVinculos = vinculos[0] + ' Y ' + vinculos[1];
      }
      if (vinculos.length == 3) {
        stringVinculos = vinculos[0] + ', ' + vinculos[1] + ' Y ' + vinculos[2];
      }
    }

    let nuevosAutorizantes = [];
    _.forEach(this.state.autorizacion.autorizantes, autorizante => {
      nuevosAutorizantes.push({
        ...autorizante.persona,
        vinculo: autorizante.vinculo,
      });
    });

    let textoOperacion = `Este tramite fue exento del pago de tasa de justicia - Ley N° 1971 Art. 3 -`;
    if (this.state.autorizacion && this.state.autorizacion.venta) {
      let venta = this.state.autorizacion.venta;
      textoOperacion = `Por este trámite se abono la suma de $${
        venta.importe
      } mediante el uso de ${
        venta.tipoPago
      }, en concepto de pago de tasa de justicia - Ley N° 1971 Art. 3 -`;
    }
    let datos = {
      autorizado: {
        ...this.state.autorizacion.autorizado,
        fecha_nacimiento: this.state.autorizacion.autorizado.fecha_nacimiento
          ? moment(this.state.autorizacion.autorizado.fecha_nacimiento).toDate()
          : '',
        edad: this.state.autorizacion.autorizado.fecha_nacimiento
          ? Math.floor(
              moment(new Date()).diff(
                moment(this.state.autorizacion.autorizado.fecha_nacimiento),
                'years',
                true
              )
            )
          : '',
      },
      idAutorizacion: this.state.autorizacion._id,
      autorizantes: [...nuevosAutorizantes],
      autorizantes_sin_domicilio: [...nuevosAutorizantes],
      autorizantes_con_domicilio: [...nuevosAutorizantes],
      autorizantes_con_formatoHtml: [...nuevosAutorizantes],
      autorizantes_trabajo_menor: [...nuevosAutorizantes],
      certifica_trabajo_menor: [...nuevosAutorizantes],
      autorizantes_firmas: [...nuevosAutorizantes],
      responsables: [...this.state.autorizacion.responsables],
      responsables_simple: [...this.state.autorizacion.responsables],
      responsables_sin_domicilio: [...this.state.autorizacion.responsables],
      empleador: this.state.empleador,
      vinculos: stringVinculos,
      numero_acta_nacimiento: this.state.autorizacion.numero_acta_nacimiento,
      domicilioActividad: this.state.autorizacion.domicilioActividad,
      cantidad_dias: this.state.autorizacion.cantidad_dias,
      desde: moment(this.state.autorizacion.desde).format('DD/MM/YYYY'),
      hasta: moment(this.state.autorizacion.hasta).format('DD/MM/YYYY'),
      // tipo_autorizacion: this.state.tipo_autorizacion,
      numero: this.state.numero,
      mailsNotificar: this.state.mailsNotificar,
      telefonos: this.state.telefonos,
      destinos: this.state.autorizacion.destinos,
      organismo: this.state.autorizacion.organismo,
      venta: this.state.autorizacion.venta,
      textoOperacion: textoOperacion,
      codigoQr: this.state.autorizacion._id,
      codigoUnicoVerificacion: this.state.autorizacion.codigoUnicoVerificacion,
    };
    return datos;
  }

  finProcesoGeneracion(textoGenerado) {
    this.setState(
      {
        ...this.state,
        nota: {
          ...this.state.nota,
          htmlModelo: textoGenerado,
        },
      },
      function() {
        //Esta es una declaracion de una funcion sincronica, que espera a que el setState se haga para ejecutarse. Un Callback
        // console.log("Entre al sync");
        this.siguientePaso();
        // console.log("llame al siguiente paso");
      }
    );

    // console.log("El estado queda de la siguiente manera");
    // console.log(this.state);

    // this.siguientePaso();
  }

  async onImprimir(htmlFinal) {
    const rta = await this.guardarAutorizacion();

    if (rta || this.state.confirmado) {
      //TODO: IMPRIMIR
      // console.log("La respuesta es.....");
      // console.log(rta);
      imprimir(htmlFinal);
    }
  }

  async guardarAutorizacion(htmlFinal) {
    const { autorizacion } = this.state;
      try {
        const rta = await this.props.updateAutorizacionTrabajoMenorPorId({
          variables: {
            _id: autorizacion._id,
            nuevaAutorizacion:{
              idModeloNota: this.state.nota.idModeloNota,
              textoHtmlGuardado: htmlFinal,
              numero: this.state.numero,
            }
          },
        });
        if (rta) {
          
          notification.success({
            message: 'Autorizacion Guardada!',
            description: 'Se ha guardado con exito la Autorizacion. Aun debe ser firmada',
          });

          this.setState({
            ...this.state,
            confirmado: true,
          });

          return rta;
        }
      } catch (err) {
        console.log('excepcion al confirmar la autorizacion');
        console.log(err);

        Modal.error({
          title: 'Error en la confirmacion de la autorizacion',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      }
  }

  guardarPersonas = () => {
    // First check age restrictions for AUTORIZADO
    const autorizados = this.props.personas.filter(p => p.rol === 'AUTORIZADO');
    for (let persona of autorizados) {
      if (!this.checkEdad(persona)) {
        return;
      }
    }

    // Then check role restrictions
    if (this.checkRestriccionRoles(this.props.personas)) {
      this.siguientePaso();
    } else {
      notification.error({
        message: 'Error en la confirmacion de la autorizacion',
        description:
          'Compruebe que todas las personas tengan un rol asignado, que exista al menos un AUTORIZADO, un AUTORIZANTE, y que no hayan multiples roles de MADRE o PADRE',
      });
    }
  };

  guardarEmpleador = (empleador) => 
    {
      
      // Save empleador to state
      this.setState({ empleador: empleador });
      
      this.props
        .insertEmpleador({
          variables: { empleador: empleador },
        })
        .then(res => {
           this.setState({ empleador: res.data.insertEmpleador });
          notification.success({
            message: 'Empleador creado',
            description: 'El empleador se ha registrado correctamente.',
          });
        })
        .catch(err => {
          console.error("Error al insertar empleador:", err);
          notification.error({
            message: 'Error al crear empleador',
            description: 'Hubo un problema al registrar el empleador.',
          });
        });
      this.siguientePaso();
    };

  checkEdad = (persona) => {
    // Only check age for AUTORIZADO role
    if (persona.rol !== 'AUTORIZADO') {
      return true;
    }

    let edad = null;

    // First, try to use the edad field if it exists
    if (persona.edad !== undefined && persona.edad !== null) {
      edad = persona.edad;
    } 
    // Otherwise, calculate from fecha_nacimiento
    else if (persona.fecha_nacimiento) {
      edad = Math.floor(
        moment(new Date()).diff(
          moment(persona.fecha_nacimiento),
          'years',
          true
        )
      );
    }

    // If we couldn't determine age, show error and return false
    if (edad === null) {
      notification.error({
        message: 'Error en la edad del autorizado',
        description:
          `No se pudo determinar la edad de ${persona.nombre} ${persona.apellido}. Por favor, verifique que la persona tenga una fecha de nacimiento válida.`,
      });
      return false;
    }

    // Check if age is between 16 and 18 (excluding 18)
    // Valid ages are: 16, 17
    if (edad >= 16 && edad < 18) {
      return true;
    } else {
      notification.error({
        message: 'Error en la edad del autorizado',
        description:
          `${persona.nombre} ${persona.apellido} tiene ${edad} años. El autorizado debe tener entre 16 y 17 años (no cumplidos los 18).`,
      });
      return false;
    }
  }

  checkRestriccionRoles = personas => {
    let bandera = true;
    let autorizado = false;
    let autorizantes = false;
    let tieneMadre = false;
    let tienePadre = false;
    
    personas.forEach(persona => {
      if (persona.rol.length == 0) {
        bandera = false;
      } else {
        if (persona.rol == 'AUTORIZADO') {
          autorizado = true;
        }
        if (
          persona.rol == 'MADRE' ||
          persona.rol == 'PADRE' ||
          persona.rol == 'GUARDADOR'
        ) {
          autorizantes = true;
          
          // Check for duplicate MADRE or PADRE roles
          if (persona.rol == 'MADRE') {
            if (tieneMadre) {
              bandera = false; // Already has a MADRE, this is a duplicate
            }
            tieneMadre = true;
          }
          if (persona.rol == 'PADRE') {
            if (tienePadre) {
              bandera = false; // Already has a PADRE, this is a duplicate
            }
            tienePadre = true;
          }
        }
        // if (persona.rol == "RESPONSABLE") {
        //   responsables = true;
        // }
      }
    });
    return bandera && autorizado && autorizantes;
  };

  crearyPersistirAutorizacion = ventaSinStock => {
    let autorizantes = [];
    let idAutorizado = '';
    let idResponsables = [];

    // console.log("LLEGUEEEEEEEE");
    // console.log(this.props);
    // console.log(this.state);

    _.each(this.props.personas, persona => {
      if (
        persona.rol == 'MADRE' ||
        persona.rol == 'PADRE' ||
        persona.rol == 'GUARDADOR'
      ) {
        autorizantes.push({ idPersona: persona._id, vinculo: persona.rol });
      } else {
        if (persona.rol == 'AUTORIZADO') {
          idAutorizado = persona._id;
        } else {
          idResponsables.push(persona._id);
        }
      }
    });

    if (this.checkRestriccionRoles(this.props.personas)) {
      if (ventaSinStock) {
        //Esto significa que debemos generar la venta de la nueva forma.
        this.crearAutorizacionConVenta(
          idAutorizado,
          autorizantes,
          idResponsables
        );
      } else {
        this.crearVenta(idAutorizado, autorizantes, idResponsables);
      }
    }
  };

  crearAutorizacionConVenta = (idAutorizado, autorizantes, idResponsables) => {
    let yo = this;

    let modeloDetalleVenta = {
      idTipo_Sello: null,
      cantidad: null,
    };

    let { existeVenta, datosPosnet, detalles, extras, datosMP } = this.state;
    let detallesFiltrados = _.map(detalles, detalle => {
      let result = _.pick(detalle, _.keys(modeloDetalleVenta));

      return result;
    });
    let { email, enviarPorEmail, descargarRecibo } = extras;
    let venta;

    if (existeVenta && detalles.length > 0) {
      venta = {
        idVendedor: this.props.data.getUsuario._id,
        idOrganismo: this.props.data.getUsuario.organismo._id,
        detalle: detallesFiltrados,
        datosPosnet:
          (datosPosnet && (datosPosnet.codigoOperacion || datosPosnet.numeroTicket))
            ? {
                codigoOperacion: datosPosnet.codigoOperacion,
                numeroTicket: datosPosnet.numeroTicket,
                cuenta: 'Tasas',
              }
            : null,
        datosMP: datosMP
          ? { numeroComprobante: datosMP.numeroComprobante }
          : null,
        datosRecibo: {
          email,
          enviarPorEmail,
          descargarRecibo,
        },
      };
    }

    let datos = {
      numero_acta_nacimiento: this.state.numero_acta_nacimiento,
      domicilioActividad: this.state.domicilioActividad,
      cantidad_dias: this.state.cantidad_dias,
      desde: this.state.desde,
      hasta: this.state.hasta,
      mailsNotificar: this.state.mailsNotificar,
      telefonos: this.state.telefonos,
      idAutorizado,
      autorizantes,
      idResponsables,
      idEmpleador: this.state.empleador._id,
      idOrganismo: this.props.data.getUsuario.organismo._id,
      idCreador: this.props.data.getUsuario._id,
      tipoVenta: venta.datosPosnet ? 'POSNET' : 'EFECTIVO',
    };
    confirm({
      title: 'Está seguro de que desea confirmar?',
      content: 'No podrá hacer cambios sobre esta autorizacion',
      onOk: () => {
        yo.setState(
          {
            loading: true,
          },
          () =>
            this.props
              .crearAutorizacionTrabajoMenor({
                variables: { autorizacion: datos, venta: venta },
              })
              .then(respuestaAutorizacion => {
                if (venta) {
                  notification.success({
                    message: 'Venta registrada',
                    description: 'La venta se registro de forma exitosa',
                  });
                }
                notification.success({
                  message: 'Nueva Autorizacion',
                  description: 'Se ha registrado con exito la autorizacion',
                });

                if (
                  descargarRecibo &&
                  respuestaAutorizacion.data.crearAutorizacionTrabajoMenor &&
                  respuestaAutorizacion.data.crearAutorizacionTrabajoMenor.venta &&
                  respuestaAutorizacion.data.crearAutorizacionTrabajoMenor.venta
                    .recibo64
                ) {
                  verPdf(
                    respuestaAutorizacion.data.crearAutorizacionTrabajoMenor.venta
                      .recibo64,
                    `Recibo_Num_${
                      respuestaAutorizacion.data.crearAutorizacionTrabajoMenor.venta.id
                    }`
                  );
                }

                this.setState(
                  {
                    ...this.state,
                    guardado: true,
                    pendienteCargaPersona: false,
                    loading: false,
                    autorizacion: {
                      ...respuestaAutorizacion.data.crearAutorizacionTrabajoMenor,
                    },
                  },
                  () => {
                    yo.siguientePaso();
                  }
                );
              })
              .catch(error => {
                console.log('Excepcion!!');
                console.log(error);
                errorService(error, {
                  autorizacion: datos,
                });
                this.setState({
                  loading: false,
                });
                Modal.error({
                  title:
                    'Error en la creacion de la autorizacion del viaje de un menor',
                  content:
                    'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
                });
              })
        );
      },
      onCancel() {
        console.log('Cancel');
        yo.setState({
          loading: false,
        });
      },
    });
  };

  crearVenta = (idAutorizado, autorizantes, idResponsables) => {
    let yo = this;

    let modeloDetalleVenta = {
      idTipo_Sello: null,
      cantidad: null,
    };

    let { existeVenta, datosPosnet, detalles } = this.state;
    let detallesFiltrados = _.map(detalles, detalle => {
      let result = _.pick(detalle, _.keys(modeloDetalleVenta));

      return result;
    });

    if (existeVenta && detalles.length > 0) {
      confirm({
        title: 'Está seguro de que desea crear la autorizacion CON VENTA?',
        content: 'No podrá hacer cambios sobre esta autorizacion',
        onOk: () => {
          yo.setState(
            {
              loading: true,
            },
            () =>
              this.props
                .insertDetalleVenta({
                  variables: { detalleVenta: { detalle: detallesFiltrados } },
                })
                .then(res => {
                  //El detalle de venta se inserto correctamente. Ahora debemos crear la venta..
                  let detalles = res.data.insertDetalleVenta.detalle;

                  let importe = _.sum(
                    _.map(detalles, detalle => {
                      //Esta funcion se encarga de multiplicar la cantidad de cada de talle por el valor de cada tipo_sello
                      return detalle.cantidad * detalle.tipo_sello.valor;
                    })
                  );

                  let venta = {
                    importe: importe,
                    fecha: moment().toDate(),
                    idVendedor: this.props.data.getUsuario._id,
                    idOrganismo: this.props.data.getUsuario.organismo._id,
                    idDetalle_Venta: res.data.insertDetalleVenta._id,
                    datosPosnet:
                      (datosPosnet && (datosPosnet.codigoOperacion || datosPosnet.numeroTicket))
                        ? {
                            codigoOperacion: datosPosnet.codigoOperacion,
                            numeroTicket: datosPosnet.numeroTicket,
                            cuenta: 'Tasas',
                          }
                        : null,
                  };

                  this.props
                    .insertVenta({
                      variables: { venta: venta },
                    })
                    .then(res => {
                      let datos = {
                        numero_acta_nacimiento: this.state
                          .numero_acta_nacimiento,
                        cantidad_dias: this.state.cantidad_dias,
                        destinos: this.state.destinos,
                        desde: this.state.desde,
                        hasta: this.state.hasta,
                        idEmpleador: this.state.empleador._id,
                        idAutorizado,
                        autorizantes,
                        idResponsables,
                        mailsNotificar: this.state.mailsNotificar,
                        telefonos: this.state.telefonos,
                        // mailsNotificar: this.props.data.mailsNotificar,
                        idOrganismo: this.props.data.getUsuario.organismo._id,
                        idCreador: this.props.data.getUsuario._id,
                        idVenta: res.data.insertVenta._id,
                        tipoVenta: venta.datosPosnet ? 'POSNET' : 'EFECTIVO',
                      };

                      this.props
                        .createAutorizacion({
                          variables: { autorizacion: datos },
                        })
                        .then(respuestaAutorizacion => {

                          notification.success({
                            message: 'Nueva Autorizacion',
                            description:
                              'Se ha registrado con exito la autorizacion',
                          });

                          notification.success({
                            message: 'Venta registrada',
                            description:
                              'La venta se registro de forma exitosa',
                          });

                          this.setState(
                            {
                              ...this.state,
                              guardado: true,
                              pendienteCargaPersona: false,
                              loading: false,
                              autorizacion: {
                                ...respuestaAutorizacion.data
                                  .insertAutorizacionTrabajoMenor,
                              },
                            },
                            () => {
                              yo.siguientePaso();
                            }
                          );
                        })
                        .catch(error => {
                          console.log('Excepcion!!');
                          console.log(error);
                          errorService(error, {
                            autorizacion: datos,
                          });
                          this.setState({
                            loading: false,
                          });
                          Modal.error({
                            title:
                              'Error en la creacion de la autorizacion del viaje de un menor',
                            content:
                              'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
                          });
                        });

                      return res;
                    })
                    .catch(err => {
                      console.log('Se ha producido un error');
                      console.log(err);
                      errorService(err, {
                        venta: venta,
                      });
                      this.setState({
                        loading: false,
                      });
                      notification.error({
                        message: 'Error al registrar la venta',
                        description:
                          'Se ha producido un error al registrar la venta',
                      });

                      return err;
                    });
                })
                .catch(err => {
                  console.log(
                    'Ocurrio un error a la hora de registrar el detalle de la venta'
                  );
                  console.log(err);
                  errorService(err, {
                    detalleVenta: { detalle: detallesFiltrados },
                  });
                  this.setState({
                    loading: false,
                  });
                  Modal.error({
                    title:
                      'Error en la creacion de la venta, compruebe que exista stock por favor',
                    content:
                      'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
                  });
                })
          );
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    } else {
      //caso donde solo debo crear la certificacion:

      // console.log('NO DEBO CREAR LAS COASS!!!');
      // console.log(this.state.existeVenta);

      let datos = {
        numero_acta_nacimiento: this.state.numero_acta_nacimiento,
        domicilioActividad: this.state.domicilioActividad,
        cantidad_dias: this.state.cantidad_dias,
        destinos: this.state.destinos,
        desde: this.state.desde,
        hasta: this.state.hasta,
        idEmpleador: this.state.empleador._id,
        idAutorizado,
        autorizantes,
        idResponsables,
        mailsNotificar: this.state.mailsNotificar,
        telefonos: this.state.telefonos,
        idOrganismo: this.props.data.getUsuario.organismo._id,
        idCreador: this.props.data.getUsuario._id,
        tipoVenta: 'EXENTO',
      };

      confirm({
        title: 'Está seguro de que desea crear la autorizacion SIN VENTA?',
        content: 'No podrá hacer cambios sobre esta autorizacion',
        onOk: () => {
          yo.setState(
            {
              loading: true,
            },
            () =>
              this.props
                .createAutorizacion({
                  variables: { autorizacion: datos },
                })
                .then(respuestaAutorizacion => {

                  notification.success({
                    message: 'Nueva Autorizacion',
                    description: 'Se ha registrado con exito la autorizacion',
                  });

                  this.setState(
                    {
                      ...this.state,
                      guardado: true,
                      pendienteCargaPersona: false,
                      loading: false,
                      autorizacion: {
                        ...respuestaAutorizacion.data.insertAutorizacionTrabajoMenor,
                      },
                    },
                    () => {
                      yo.siguientePaso();
                    }
                  );
                })
                .catch(error => {
                  console.log('Excepcion!!');
                  console.log(error);
                  errorService(error, {
                    autorizacion: datos,
                  });
                  this.setState({
                    loading: false,
                  });
                  Modal.error({
                    title:
                      'Error en la creacion de la autorizacion del viaje de un menor',
                    content:
                      'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
                  });
                })
          );
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    }
  };

  ModeloNotaElegido = idNota => {
    // console.log("La nota tiene el id de ....", this.state.nota.idModeloNota);

    this.setState(
      {
        ...this.state,
        nota: {
          ...this.state.nota,
          idModeloNota: idNota.modelo,
        },
        loading: true,
      },
      () => {
        // console.log("Entre!");

        this.props.client
          .mutate({
            mutation: obtenerNumeroTalonario,
            variables: {
              idModeloNota: this.state.nota.idModeloNota,
            },
          })
          .then(respuesta => {
            // console.log("Recibi de respuesta....");
            // console.log(respuesta);

            if (respuesta.data.obtenerNumeroTalonario == -1) {
              notification.warning({
                message: 'Talonario no configurado',
                description:
                  'El modelo de nota no tiene configurado el talonario a usar',
              });
            }

            this.setState({
              ...this.state,
              numero: respuesta.data.obtenerNumeroTalonario
                ? respuesta.data.obtenerNumeroTalonario
                : 0,
              loading: false,
            });

            // console.log("ESTADO: ");
            // console.log(this.state);
            this.siguientePaso();
          })
          .catch(err => {
            console.log('ERROR a la hora de obtener el numero del  talonario');
            console.log(err);
            errorService(err, {
              idModeloNota: this.state.nota.idModeloNota,
            });
          });
      }
    );
  };

  onCancel() {
    //El cancelar reinicia todo el estado de la aplicacion para volver a empezar desde 0
    this.setState({
      nota: {
        idModeloNota: '',
        titulo: '',
        descripcion: '',
        htmlModelo: '',
      },
      autorizado: {},
      autorizante: {},
      responsable: {},
      vinculo_autorizante: '',
      numero_acta_nacimiento: '',
      domicilioActividad: '',
      cantidad_dias: '',
      // tipo_autorizacion: "",
      step: 0,
      guardado: false,
    });

    this.props.history.push('/');
  }

  siguientePaso() {
    //Metodo que se encarga de aumentar en 1 el paso y es llamado por todos los metodos auxiliares
    let paso = this.props.main.step;
    paso++;
    this.setState(
      {
        ...this.state,
        step: paso,
      },
      () => {
        this.props.actionsMain.setPaso(paso);
      }
    );

    // console.log("Estoy en el paso: ", paso, " con el estado: ", this.state);
  }

  anteriorPaso() {
    console.log("----------Saliendo---------");
    let paso = this.props.main.step;
    if (paso > 0) {
      paso--;
      this.setState(
        {
          ...this.state,
          step: paso,
        },
        () => {
          this.props.actionsMain.setPaso(paso);
        }
      );
    }
  }

  render() {
    const { Step } = Steps;
    // let { step } = this.state;
    let { step } = this.props.main;

    if (this.state.loading) {
      return <Loading />;
    }

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Autorizacion</Breadcrumb.Item>
          <Breadcrumb.Item>Viaje de Menor</Breadcrumb.Item>
          <Breadcrumb.Item>Nueva</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Nueva Autorizacion Trabajo Adolescente{' '}
          </h2>
          <br />

          {step != 5 && (
            <Steps size="small" className="stepsFormularios" current={step}>
              <Step title="Involucrados" />
              <Step title="Datos Empleador" />
              <Step title="Datos Autorizacion" />
              <Step title="Modelo Nota" />
              <Step title="Generacion de Nota" />
              <Step title="Editar e Imprimir" />
            </Steps>
          )}
          <Content>
            <div style={estiloContent}>
              {step === 0 && (
                <VerPersonas
                  history={this.props.history}
                  onSubmit={this.guardarPersonas}
                />
              )}

              {step === 1 && (
                <CrearEmpleador
                  history={this.props.history}
                  onSubmit={this.guardarEmpleador}
                  onCancel={this.anteriorPaso}
                  empleadorData={this.state.empleador}
                />
              )}

              {step === 2 && (
                <FormAutorizacionTrabajoMenor
                  organismo={this.props.data.getUsuario.organismo}
                  usuario={this.props.data.getUsuario}
                  personas={this.props.personas}
                  onFinalizar={this.guardarDatosAutorizacion}
                  onSubmit={this.guardarDatosAutorizacion}
                  config={{ creacion: true }}
                  datos={{
                    numero_acta_nacimiento: this.state.numero_acta_nacimiento,
                    cantidad_dias: this.state.cantidad_dias,
                    destinos: this.state.destinos,
                    domicilioActividad: this.state.empleador.domicilio
                  }}
                />
              )}

              {step === 3 && (
                <SelectorModelo
                  handleChange={this.notaSeleccionada}
                  onSubmit={this.ModeloNotaElegido}
                />
              )}
              {step === 4 && (
                <Generador
                  id={this.state.nota.idModeloNota}
                  // datos={this.state.persona}
                  datos={this.obtenerDatosGeneracion()}
                  mostrarEditor={this.finProcesoGeneracion}
                />
              )}
              {step === 5 && (
                <CKEditor
                  modelo_nota={this.state.nota}
                  onImprimir={this.onImprimir}
                  onCancel={this.onCancel}
                  onGuardar={this.guardarAutorizacion}
                  accion="visualizar"
                />
              )}
            </div>
          </Content>
        </Layout>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actionsAutorizacion: bindActionCreators(actionsAutorizacion, dispatch),
  actionsMain: bindActionCreators(actionsMain, dispatch),
});

function mapStateToProps(state) {
  return state;
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withApollo(CrearAutorizacionTrabajoMenor));
